module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/101VNTe/images/cover.jpg?1703000751183",
      "alt": "This image is the cover for the book Pantheon High, Volume 1, Pantheon High"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Pantheon High, Volume 1, Pantheon High\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Danger looms when the gods of the world send their kids to high school in this manga series debut that “")]), _c('b', [_vm._v("entertains with intelligence and humor” ("), _c('i', [_vm._v("Publishers Weekly")]), _vm._v(").")])]), _c('p', [_vm._v(" Welcome to a modern-day world where the deities of all religions coexist. Norse Gods roam Asgard, Greek Gods rule Mount Olympus, Egyptian Gods orbit around Ra, Japanese Gods bestow luck and wisdom . . . and their demigod children all attend the same private high school in Los Angeles!  ")]), _c('p', [_vm._v(" The students of Pantheon High aren’t your typical bunch. Grace wonders is she’ll ever understand her father Tyr, the Norse god of war. Griffin, child of Hades, is having a hell of a time adjusting. Yukio, son of Benten, gets by on his endless luck, while Aziza, daughter of Ra, has the heat of the sun at her fingertips. But when evil gods from across the globe band together, these mythical teens are the only ones who can stop them from plunging the world into darkness! ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Paul Benjamin, Steven Cummings, Megumi Cummings\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Tokyopop Verlag\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0